var map = {
	"./annamonica.png": 6329,
	"./designdialects.png": 7268,
	"./domipack.png": 4924,
	"./dostudio.png": 4502,
	"./edubims.png": 4589,
	"./esordio.png": 2935,
	"./gopacc.png": 5326,
	"./hearvox.png": 2958,
	"./kaya.png": 7266,
	"./kidgage.png": 8923,
	"./kotilights.png": 1338,
	"./lealtainternational.png": 1434,
	"./learnersbusinessschool.png": 7418,
	"./learnersqatar.png": 2734,
	"./learnersuae.png": 5658,
	"./leckok.png": 8270,
	"./manalawfirm.png": 7015,
	"./maven.png": 5558,
	"./mbaprogram.png": 2138,
	"./mckutty.png": 631,
	"./mejestic.png": 6810,
	"./movingcloud.png": 7635,
	"./nmholding.png": 6811,
	"./pablo.png": 1165,
	"./pca.png": 4275,
	"./podbabies.png": 4385,
	"./proto.png": 6509,
	"./pythonbull.png": 4126,
	"./qatarcinema.png": 5960,
	"./rolacc.png": 303,
	"./skillhub.png": 2475,
	"./techffoldis.png": 2708,
	"./triangles.png": 7304,
	"./upcarrera.png": 8382,
	"./watch.png": 8581,
	"./zainbuilders.png": 1104
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8796;